const checkbox = document.querySelector('.js-call-me-back-checkbox');
const row = document.querySelector('.js-call-me-back-row');

const callMeBack = {
  initialize() {
    if (checkbox && row) {
      this.createEvents();
    }
  },

  createEvents() {
    checkbox.addEventListener('change', (e) => {
      row.style.display = e.target.checked ? 'flex' : 'none';

      const formElements = row.querySelectorAll('input, select');
      Array.prototype.slice.call(formElements);

      formElements.forEach(el => el.toggleAttribute('required', e.target.checked));
    });
  },
};

export default callMeBack;
